module.exports = __webpack_public_path__ + "img/agro-min.f5aa1107.png";